var map = {
	"./custom/app/shared/object-collection/shared/badges/access-status-badge/access-status-badge.component": [
		8402,
		"src_themes_custom_app_shared_object-collection_shared_badges_access-status-badge_access-statu-f5960a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 29381;
module.exports = webpackAsyncContext;